import { useShopConfig } from './shopConfig';
import { CreditPayoutOption, isGiftCardOption } from '../shopConfig/shops/default';

export enum PayoutMethod {
  PactCash = 'pactCash',
  GiftCard = 'giftCard',
  Discount = 'discount',
  YotpoPoints = 'yotpoPoints',
}

type PayoutMethodText = {
  [PayoutMethod.PactCash]: string;
  [PayoutMethod.GiftCard]: string;
  [PayoutMethod.Discount]: string;
  [PayoutMethod.YotpoPoints]: string;
};

export function useCreditPayoutText(): {
  getCreditPayoutText: (payoutMethodToText: PayoutMethodText) => string;
} {
  const { creditPayoutOption } = useShopConfig();

  const isPayoutGiftCard = isGiftCardOption(creditPayoutOption);
  const isPayoutPactCash = creditPayoutOption === CreditPayoutOption.PactCash;
  const isPayoutYotpoPoints = creditPayoutOption === CreditPayoutOption.YotpoLoyaltyPoints;

  const getCreditPayoutText = (payoutMethodToText: PayoutMethodText) => {
    if (isPayoutPactCash) {
      return payoutMethodToText.pactCash;
    }
    if (isPayoutGiftCard) {
      return payoutMethodToText.giftCard;
    }
    if (isPayoutYotpoPoints) {
      return payoutMethodToText.yotpoPoints;
    }
    return payoutMethodToText.discount;
  };

  return {
    getCreditPayoutText,
  };
}
